export const DEFAULT_FACEBOOK_COLUMN_VALUES = {
  metaTotalPurchases1DClick: 0,
  metaTotalPurchases1DView: 0,
  metaTotalPurchases7DClick: 0,
  metaTotalPurchases7DClick1DView: 0,
  metaShopPurchases1DClick: 0,
  metaShopPurchases7DClick: 0,
  metaShopPurchases7DClick1DView: 0,
  metaOffsitePixelPurchases1DClick: 0,
  metaOffsitePixelPurchases7DClick: 0,
  metaOffsitePixelPurchases7DClick1DView: 0,
  metaTotalRevenue1DClick: 0,
  metaTotalRevenue7DClick: 0,
  metaTotalRevenue7DClick1DView: 0,
  metaShopRevenue1DClick: 0,
  metaShopRevenue7DClick: 0,
  metaShopRevenue7DClick1DView: 0,
  metaOffsitePixelRevenue1DClick: 0,
  metaOffsitePixelRevenue7DClick: 0,
  metaOffsitePixelRevenue7DClick1DView: 0,
  metaImprs: 0,
  metaVideoPlayActions7DClick1DView: 0,
  metaVideoPlayActions1DView: 0,
  metaVideoThruplayWatchedActions7DClick1DView: 0,
  metaVideoThruplayWatchedActions1DView: 0,
  metaOfflineRevenue1DClick: 0,
  metaOfflineRevenue7DClick: 0,
  metaOfflineRevenue7DClick1DView: 0,
  metaMobileAppRevenue1DClick: 0,
  metaMobileAppRevenue7DClick: 0,
  metaMobileAppRevenue7DClick1DView: 0,
  metaOfflinePurchases1DClick: 0,
  metaOfflinePurchases7DClick: 0,
  metaOfflinePurchases7DClick1DView: 0,
  metaMobileAppPurchases1DClick: 0,
  metaMobileAppPurchases7DClick: 0,
  metaMobileAppPurchases7DClick1DView: 0,
  metaOutboundClicks: 0,
  metaLinkClicks: 0,

  meta3SVideoViewsDefault: 0,

  metaShopPurchases1DView: 0,
  metaOfflinePurchases1DView: 0,
  metaMobileAppPurchases1DView: 0,
  metaOffsitePixelPurchases1DView: 0,
  metaTotalRevenue1DView: 0,
  metaShopRevenue1DView: 0,
  metaOfflineRevenue1DView: 0,
  metaOffsitePixelRevenue1DView: 0,
  metaMobileAppRevenue1DView: 0,
  metaSpend: 0,

  metaPostEngagement1DView: 0,
  metaPostEngagement1DClick: 0,
  metaPostEngagement7DClick: 0,
  metaPostEngagement7DClick1DView: 0,
  metaPostEngagementDefault: 0,
  metaPageEngagement1DView: 0,
  metaPageEngagement1DClick: 0,
  metaPageEngagement7DClick: 0,
  metaPageEngagement7DClick1DView: 0,
  metaPageEngagementDefault: 0,
  metaPageLikes1DView: 0,
  metaPageLikes1DClick: 0,
  metaPageLikes7DClick: 0,
  metaPageLikes7DClick1DView: 0,
  metaPageLikesDefault: 0,
  metaVideoContinuous2SecWatchedActions: 0,

  meta3SVideoViews1DClick: 0,
  meta3SVideoViews7DClick: 0,
  meta3SVideoViews7DClick1DView: 0,
  metaVideoP25Watched: 0,
  metaVideoP50Watched: 0,
  metaVideoP75Watched: 0,
  metaVideoP95Watched: 0,
  metaVideoP100Watched: 0,
};

export const METRIC_POINT_DEFAULTS = {
  spend: 0,
  imprs: 0,
  pRev: 0,
  pTxns: 0,
  pVisits: 0,

  visits: 0,
  newVisits: 0,
  convs: [],
  goals: [],

  extraRev_to_30: 0,
  extraRev_to_60: 0,
  extraRev_to_90: 0,

  extraTxns_to_30: 0,
  extraTxns_to_60: 0,
  extraTxns_to_90: 0,

  ...DEFAULT_FACEBOOK_COLUMN_VALUES,

  // GOOGLE

  googleAllConversions: 0,
  googleAllConversionsValue: 0,
  googleImpressions: 0,
  googleClicks: 0,
  googleVideoViews: 0,
  googleViewThroughConversions: 0,
  googleConversions: 0,
  googleConversionsValue: 0,
  googleSpend: 0,

  // TIKTOK

  tiktokVideoViews: 0,
  tiktokVideoViews2s: 0,
  tiktokVideoViews6s: 0,
  tiktokVideoViewsP100: 0,
  tiktokVideoViewsP75: 0,
  tiktokVideoViewsP50: 0,
  tiktokVideoViewsP25: 0,
  tiktokImprs: 0,
  tiktokLikes: 0,
  tiktokClicks: 0,
  tiktokCompletePayment: 0,
  tiktokTotalCompletePayment: 0,
  tiktokEngagements: 0,
  tiktokSpend: 0,
  tiktokGMVNetCost: 0,
  tiktokGMVCostPerOrder: 0,
  tiktokGMVGrossRevenue: 0,
  tiktokGMVCostPerLiveView: 0,
  tiktokGMVCostPer10SecondLiveView: 0,
  tiktokGMVOrders: 0,
  tiktokGMVLiveViews: 0,
  tiktokGMVTenSecondLiveViews: 0,
  tiktokGMVLiveFollows: 0,
  // SNAPCHAT

  snapchatSpend: 0,
  snapchatPaidImpressions: 0,
  snapchatEarnedImpressions: 0,
  snapchatTotalImpressions: 0,
  snapchatSwipes: 0,
  snapchatProfileClicks: 0,
  snapchatVideoViews: 0,
  snapchatVideoViewsTimeBased: 0,
  snapchatVideoViews15S: 0,
  snapchatQuartile1: 0,
  snapchatQuartile2: 0,
  snapchatQuartile3: 0,
  snapchatViewCompletion: 0,
  snapchatAttachmentTotalViewTimeMillis: 0,
  snapchatRevenueMicrocurrency: 0,
  snapchatTransactions: 0,

  // PINTEREST

  pinterestCheckoutConversions: 0,
  pinterestCheckoutOrderValue: 0,
  pinterestPageVisitConversions: 0,
  pinterestAddToCartClickConversions: 0,
  pinterestPaidImpressions: 0,
  pinterestPaidEngagements: 0,
  pinterestPaidPinClicks: 0,
  pinterestPaidSaves: 0,
  pinterestPaidIdeaPinProductTagVisit: 0,
  pinterestSpendInAccountCurrency: 0,
  pinterestPaidVideoViews: 0,
  pinterestPaid3SecVideoViews: 0,
  pinterestPaidVideoPlayedAt25: 0,
  pinterestPaidVideoPlayedAt50: 0,
  pinterestPaidVideoPlayedAt75: 0,
  pinterestPaidVideoPlayedAt95: 0,
  pinterestPaidVideoPlayedAt100: 0,
  pinterestPaidVideoStarts: 0,

  // TWITTER

  twitterClicks: 0,
  twitterAppClicks: 0,
  twitterLikes: 0,
  twitterFollows: 0,
  twitterRetweets: 0,
  twitterUnfollows: 0,
  twitterEngagements: 0,
  twitterReplies: 0,
  twitterUrlClicks: 0,

  // TRADEDESK

  tradedeskImpressions: 0,
};
